// extracted by mini-css-extract-plugin
export var searchHeader = "_8e-0";
export var searchHeaderDark = "_8e-1";